<template>
    <svg width="12px" height="12px" viewBox="0 0 12 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="wellness-tooltip-factor" transform="translate(0, -1)" fill="#96F189" fill-rule="nonzero">
                <g id="ic_check_success_alt_24" transform="translate(0, 1)">
                    <path d="M5.16,8.76 L9.39,4.53 L8.55,3.69 L5.16,7.08 L3.45,5.37 L2.61,6.21 L5.16,8.76 Z M6,12 C5.17,12 4.39,11.8425 3.66,11.5275 C2.93,11.2125 2.295,10.785 1.755,10.245 C1.215,9.705 0.7875,9.07 0.4725,8.34 C0.1575,7.61 0,6.83 0,6 C0,5.17 0.1575,4.39 0.4725,3.66 C0.7875,2.93 1.215,2.295 1.755,1.755 C2.295,1.215 2.93,0.7875 3.66,0.4725 C4.39,0.1575 5.17,0 6,0 C6.83,0 7.61,0.1575 8.34,0.4725 C9.07,0.7875 9.705,1.215 10.245,1.755 C10.785,2.295 11.2125,2.93 11.5275,3.66 C11.8425,4.39 12,5.17 12,6 C12,6.83 11.8425,7.61 11.5275,8.34 C11.2125,9.07 10.785,9.705 10.245,10.245 C9.705,10.785 9.07,11.2125 8.34,11.5275 C7.61,11.8425 6.83,12 6,12 Z" id="Shape"></path>
                </g>
            </g>
        </g>
    </svg>
</template>
    
<script>
   export default {
    name: 'IconSuccess',
    props: {
        color: {
          type: String,
          default: "#75FB4C",
        },
     }
   }
</script>